import { render, staticRenderFns } from "./aboutDialog.vue?vue&type=template&id=5c66eb81&scoped=true"
import script from "./aboutDialog.vue?vue&type=script&lang=js"
export * from "./aboutDialog.vue?vue&type=script&lang=js"
import style0 from "./aboutDialog.vue?vue&type=style&index=0&id=5c66eb81&prod&lang=scss"
import style1 from "./aboutDialog.vue?vue&type=style&index=1&id=5c66eb81&prod&scoped=true&lang=scss"
import style2 from "./aboutDialog.vue?vue&type=style&index=2&id=5c66eb81&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c66eb81",
  null
  
)

export default component.exports